import './Navbar.css'
import Button from '@material-ui/core/Button'
import { headers } from './constants'

const NavBar = ({ onChangeTab }) => {
  return (
    <div className="TopArea">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '0vh',
          padding: '3%',
        }}
      >
        <div style={{ marginLeft: '2vw' }}>
          <strong
            style={{ fontSize: '1.8rem', cursor: 'pointer' }}
            onClick={() => onChangeTab('home')}
          >
            ubuntu.
          </strong>
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
          }}
        >
          {headers.map((header) => {
            return (
              <a className="underLine2 hide_on_responsive">
                <Button
                  variant="text"
                  color="default"
                  onClick={() => onChangeTab(header.toLowerCase())}
                >
                  {header}
                </Button>
              </a>
            )
          })}
          <a className="underLine2">
            <Button variant="outlined" color="secondary">
              CONTACT
            </Button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default NavBar
